export enum GRNStatus {
  NEW = 1,
  PENDING = 2,
  APPROVED = 3,
  REJECTED = 4,
  PAYMENT_PROGRESS = 5,
  PAID = 6,
}

export enum GRNPaymentStatus {
  PENDING_APPROVAL = 1,
  APPROVED = 2,
  REJECTED = 3,
  PAID = 4,
}
